<template>
  <div style="margin-bottom:20px">
    <h3 class="ui dividing header">
      <i class="history icon" style="overflow: visible;position: relative;"></i>
      <div class="content">
        Iepriekš pasūtītās preces
      </div>
    </h3>

    <div class="ui stackable three cards">

      <div v-for="(item,index) in goods" class="ui fluid card" style="position:relative; margin-right: 10px"
        :key="item.id" :id="item.id" :index="index"
        v-bind:class="[{complementary_view:in_complementary==item.id && complementary_index==index},{replacement_view:in_replacement==item.id && replacement_index==index}]">


        <div class="badges" style="display:inline-block;">
          <discount-tag style="display:inline-block;" v-bind:item="item"></discount-tag>
          <div v-for="badge in item.badges" :key="badge.id" class="ui labels" style="display:inline-block;">
            <a class="ui label" :style="{ backgroundColor: '#'+ badge.color, color: '#210404'}">{{badge.label}}</a>
          </div>
        </div>



        <!-- arrows -->
        <!-- <div v-if="outofstock===item.id">
            <i class="chevron left icon" style="left:0px;position:absolute;top:25%"></i>
            <i class="chevron right icon" style="top:0px;right:0px;position:absolute;top:25%"></i>
            </div>-->
        <!-- buttons -->
        <!-- <div v-if="item.alternative_goods.length>0 && show_complementary===item.id">
            </div>-->

        <!-- only show if in replacement -->

        <div style="position:relative;margin-left:10px;margin-right:11px;text-align: center;" class="img_height">

          <div v-if="in_complementary==item.id || in_replacement==item.id">
            <button :item-id="item.id" v-if="in_replacement==item.id && replacement_index==index "
              @click="replacement(index, item, -2)" class="circular ui icon button replacement close shadow">
              <div>
                <span style="font-size:20px">
                  <!-- <strong v-if="item.related_goods!=null">{{item.related_goods.length}}</strong> -->
                  <strong>
                    <i class="close icon"></i>
                  </strong>
                </span>
                <span style="font-size:12px;word-break: break-all;display: block;margin-top: 5px;">
                  <small class="options">Līdzīgas preces</small>
                </span>
              </div>
            </button>
            <!-- show only if in complementary  -->
            <button :item-id="item.id" v-if="in_complementary==item.id && complementary_index==index"
              @click.stop="complementary(index,item,-2)" class="circular ui icon custom_brown button complementary close shadow">
              <div>
                <span style="font-size:20px">
                  <strong>
                    <i class="close icon"></i>
                  </strong>
                </span>
                <span>
                  <small class="options">Saistītās preces</small>
                </span>
              </div>
            </button>
          </div>

          <div class="">
            <button
              v-if=" outofstock===item.id && !in_replacement && !in_complementary && replacement_array[0].length>0 && replacement_index==index"
              @click="replacement(index, item, 0)" class="circular ui icon button replacement shadow">
              <div>
                <span style="font-size:30px">
                  <strong v-if="replacement_arrow[0].length>0">{{replacement_arrow[0].length}}</strong>
                  <strong style="font-size:15px ;background-color:white" v-else>0</strong>
                </span>
                <span style>
                  <small class="options">Līdzīgas preces</small>
                </span>
              </div>
            </button>

            <button v-for="result of show_complementary" :key="result"
              v-if="result==item.id && !in_replacement && !in_complementary && complementary_array[item.id].length>0 && complementary_index==index"
              @click.stop="complementary(index,item,0)" class="circular ui icon custom_brown button complementary shadow">
              <div>
                <span style="font-size:30px">
                  <strong>{{complementary_array[item.id].length}}</strong>
                </span>
                <span>
                  <small class="options">Saistītās preces</small>
                </span>
              </div>
            </button>
          </div>


          <!-- <img class="ui centered image" v-if="item.images[0]" :src="item.images[0].url">
            <img
              class="ui centered image"
              v-else
              :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.id+'.jpg'"
              >-->
          <!-- @click="$router.push('/good/'+item.link)" -->
          <v-touch :v-if="!in_complementary==item.id && !in_replacement==item.id">
            <v-touch v-bind:enabled="in_complementary==item.id" v-on:swiperight="complementary(index,item,-1)"
              v-on:swipeleft="complementary(index,item,1)">
              <v-touch v-bind:enabled=" in_replacement==item.id" v-on:swiperight="replacement(index,item,-1)"
                v-on:swipeleft="replacement(index,item,1)">
                <img @click.stop="$router.push('/good/'+item.link)" class="ui centered image" 
                  v-if="item.images[0]" :src="item.images[0].url">
                <img @click.stop="$router.push('/good/'+item.link)" class="ui centered image"  v-else
                  :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.id+'.jpg'">

                <div
                  v-if="(in_complementary==item.id && complementary_index==index) || (in_replacement==item.id && replacement_index==index) ">
                  <a class="prev" style="left:0" v-if="in_complementary==item.id"
                    @click.stop="complementary(index,item,-1)">&#10094;</a>
                  <a class="prev" style="left:0" v-else-if="in_replacement==item.id"
                    @click.stop="replacement(index,item,-1)">&#10094;</a>
                  <a class="next" v-if="in_complementary==item.id"
                    @click.stop="complementary(index,item,1)">&#10095;</a>
                  <a class="next" v-else-if="in_replacement==item.id"
                    @click.stop="replacement(index,item,1)">&#10095;</a>
                </div>
              </v-touch>
            </v-touch>
          </v-touch>
          <div v-if="in_complementary==item.id && complementary_index==index"
            v-for="complement_id of complementary_arrow[parent_item.id]" :key="complement_id" class="carousel-dots"
            style="display:inline-block">
            <span v-if="complement_id==item.id" class="dot active custom_dots"></span>
            <span v-else class="dot custom_dots"></span>
          </div>
          <div v-if="in_replacement==item.id && replacement_index==index" v-for="related_id of replacement_arrow[0]"
            :key="related_id" class="carousel-dots" style="display:inline-block;">
            <span v-if="related_id==item.id" class="dot active custom_dots"></span>
            <span v-else class="dot custom_dots"></span>
          </div>
        </div>
        <div class="content">
          <router-link :to="'/good/'+item.link" style="margin-bottom:5px" class="header">{{item.goods_name}}
          </router-link>
          <div class="meta">
            <div class="ui tag labels pa-tag-wrapper">
              <price-tag v-bind:item="item"></price-tag>
              <a v-if="item.bail>0" class="ui green label">Drošības nauda: {{item.bail}} &euro;</a>
              <auto-ship v-bind:item="item"></auto-ship>
            </div>
          </div>
          <div class="description">{{item.description}}</div>
        </div>
        <button v-if="!checkIfInCart(item)" @click="addItemToCart(item,index)" class="ui bottom attached button">
          <i class="add icon"></i> Pievienot
        </button>
        <div v-else class="ui three bottom attached  buttons">
          <div class="ui  button" @click="reduceItemInCart(item)">
            <i class="minus icon"></i>
          </div>
          <button v-on:click="$router.push({name:'cart'})" class="ui  vertical animated button">
            <div class="ui hidden content">Uz grozu</div>
            <div class="ui visible content">
              <i class="cart icon"></i>
              {{howManyInCart(item)}} gab.
            </div>
          </button>
          <div class="ui button" @click="addItemToCart(item,index)">

            <i class="add icon popup out-of-stock-popup" :id="'good_item_'+item.id"
              data-content="Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet līdzīgās preces.">
            </i>

          </div>
        </div>
      </div>

    </div>

    <div class="ui container" style="margin-top:20px">
      <button v-on:click="repeatLastOrder" class="ui right floated custom_brown button"><i class="icon cart"></i> Atkārtot pēdējo
        pasūtījumu
      </button>
      <div class="ui clearing hidden divider"></div>
    </div>

  </div>
</template>

<script>
  import autoShip from './AutoShip';
  import price from './Price';
  import discount from './Discount';
  // import CategoryMenu from "./CategoryMenu";
  import Paginator from "./Paginator";
  import api from "../store/api";
  export default {
    computed: {
      goods() {
        //loaded from parent
        return this.$store.state.goodStore.newgoods
      },
      cart() {
        return this.$store.state.cartStore.activeCart
      },
      cartItems() {
        return this.$store.state.cartStore.items
      },
    },
    components: {
      'auto-ship': autoShip,
      'price-tag': price,
      'discount-tag': discount,
      Paginator,

    },
    data() {
      return {
        page: 1,
        isactive: false,
        // complementary_view: null,
        // replacement_view: null,
        replacement_index: "",
        complementary_index: "",
        outofstock: "", // turn on replacement button view on
        in_complementary: null, //check if browsing complementary goods
        in_replacement: null, //check if browsing replacement goods
        complementary_array: [], //array of  complementary goods
        replacement_array: [], //array of  replacemet goods
        parent_item: {}, //keep track of first element before browsing complementary and replacement goods
        complementary_arrow: [], // hold complementary goods id
        replacement_arrow: [], // hold replacement goods id
        show_complementary: [] // turn on complementary button view  for the specific good
      };
    },
    computed: {

      cart() {
        return this.$store.state.cartStore.activeCart;
      },
      cartItems() {
        return this.$store.state.cartStore.items;
      },
      goods() {
        // console.log(this.$store.state.goodStore.items);
        return this.$store.state.goodStore.lastordered;
      },
      storeStatus() {
        return this.$store.state.goodStore.status;
      },
      paginator() {
        return this.$store.state.goodStore.goodsExtraData;
      },
      searchTerm() {
        return this.$store.state.categoryStore.searchTerm;
      },
      itemsInCart() {
        const sumValues = Object.keys(this.$store.state.cartStore.items).reduce(
          (acc, value) =>
            acc + parseInt(this.$store.state.cartStore.items[value].order),
          0
        );
        return sumValues;
      },
      selectedCategory() {
        return this.$store.state.categoryStore.selectedCategory;
      },

    },
    activated: function () {
      this.isactive = false; //used to ensure that when route keeps changing we dont reload data while component is not visible
      //preload data
      this.loadActiveCart();
      if (!this.goods.length || this.goods.length == 0) this.loadGoods();
    },
    deactivated: function () {
      this.isactive = false;
      this.outofstock = "";
      this.in_complementary = null;
      this.in_replacement = null;
    },
    watch: {
      //"$route.params": "loadGoods",
      //searchTerm: "searchForGoods",
      //selectedCategory: 'exitall',
    },
    methods: {

      repeatLastOrder: function () {

        this.$store.dispatch('repeatLastCart').then((response) => {
          this.$router.push({
            name: 'cart'
          });

        }).catch((error) => {
          //refresh cart as it might cause issues
        });
      },


      checkIfInCart(item) {

        if (this.$store.state.cartStore.items.length > 0 && this.$store.state.cartStore.items.filter(function (e) { return e.good_id == item.id }).length > 0) return true;
        else return false;
      },
      howManyInCart(item) {
        if (this.checkIfInCart(item)) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) { return e.good_id == item.id });
          item.autoship_price = cartItem[0].autoship_price;
          return cartItem[0].order;
        }
        else return 0;
      },
      realPrice(item) {
        if (this.checkIfInCart(item)) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) { return e.good_id == item.id });
          return cartItem[0].price_vat;
        }
        else return item.base_price_vat;
      },
      gotoCart() {
        this.$router.push({
          name: 'cart',
        });
      },
      addItemToCart(item) {
        var itemInCart = this.checkIfInCart(item);
        if (itemInCart) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) { return e.good_id == item.id });
          var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
          updatedItem.order++;
        }
        else {
          var updatedItem = {
            order: 1,
            good_id: item.id
          }
        }

        this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {

          //show popup that we are out of goods
          if (response.data.data.order < updatedItem.order) {
            $('#top_goods_' + item.id).popup('show')
            setTimeout(function () { $('#top_goods_' + item.id).popup('destroy'); }.bind(this), 10000)
          }
          else {
            $('#top_goods_' + item.id).popup('destroy'); //remove warning about warehouse goods
          }

          item.autoship_price = response.data.data.autoship_price;
          this.$store.dispatch('loadActiveCart', this.cart.id);
        }).catch((error) => {

          console.error('Cart was not loaded')
        });

      },

      reduceItemInCart(item) {

        $('#top_goods_' + item.id).popup('destroy'); //remove warning about warehouse goods

        var itemInCart = this.checkIfInCart(item);
        if (itemInCart) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) { return e.good_id == item.id });
          var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
          updatedItem.order--;

          this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
            item.autoship_price = response.data.data.autoship_price;
            //if item is totaly removed then remove it from store
            this.$store.dispatch('loadActiveCart', this.cart.id);
          }).catch((error) => {

            console.error('Cart was not loaded')
          });

        }
      },
      checkreload(value) {
        this.in_complementary = null;
        this.in_replacement = null;
      },
      loadActiveCart: function () {
        this.$store
          .dispatch("loadActiveCart")
          .then(response => {
            this.$store.dispatch("loadCartItems", this.cart.id);
          })
          .catch(error => {
            if (error.response.status == 404) {
              //if there is no active cart then create new cart
              this.$store.dispatch("createCart");
            }
          });
      },

      loadGoods() {
        //as this is called by watcher then first check if component is activated
        var page = this.$route.params.page ? this.$route.params.page : 1;
        // if (this.isactive)
        this.$store.dispatch("loadGood", [
          page,
          this.searchTerm,
          this.selectedCategory.category,
          this.selectedCategory.categorya,
          this.selectedCategory.categoryb
        ]);
      },

      searchForGoods() {
        //check if user started to search and he is yes then move to first page so that we can show items
        if (this.$route.params.page > 1) {
          this.$router.push({
            name: "goods"
          });
        }
        this.loadGoods();
      },

      checkIfInCart(item) {
        if (
          this.$store.state.cartStore.items.length > 0 &&
          this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          }).length > 0
        )
          return true;
        else return false;
      },

      howManyInCart(item) {
        if (this.checkIfInCart(item)) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });
          item.autoship_price = cartItem[0].autoship_price;
          return cartItem[0].order;
        } else return 0;
      },

      realPrice(item) {
        if (this.checkIfInCart(item)) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });
          return cartItem[0].price_vat;
        } else return item.base_price_vat;
      },

      gotoCart() {
        this.$router.push({
          name: "cart"
        });
      },

      //get the complementary items if available
      get_complementary(item, index) {
        var complementary_id = item.alternative_goods;
        var complementary_goods = [];
        var comp_arrow = [];
        if (complementary_id.length > 0) {
          complementary_id.forEach(function (id) {
            api.get("goods/" + id).then(function (response) {
              if (response.data.data.check_in_warehouse == 1) {
                if (response.data.data.available_for_customer > 0) {
                  complementary_goods.push(response.data.data);
                  comp_arrow.push(response.data.data.id);
                }
              }
              else {
                complementary_goods.push(response.data.data);
                comp_arrow.push(response.data.data.id);
              }
            });
          });
          this.complementary_arrow[item.id] = comp_arrow;
          this.complementary_array[item.id] = complementary_goods;
          this.complementary_array.splice(item.id, 1, complementary_goods);
          //console.log(this.complementary_array[item.id]);
        }
      },
      //get the replacement items if available
      get_replacement(item, index) {
        var replacement_id = item.related_goods;
        var replacement_goods = [];
        var replace_arrow = [];
        //console.log(replacement_id);
        if (replacement_id.length > 0) {
          replacement_id.forEach(function (id) {
            api.get("goods/" + id).then(function (response) {
              //console.log(response.data.data);
              if (response.data.data.check_in_warehouse) {
                if (response.data.data.available_for_customer > 0) {
                  replacement_goods.push(response.data.data);
                  replace_arrow.push(response.data.data.id);
                }
              }
              else {
                replacement_goods.push(response.data.data);
                replace_arrow.push(response.data.data.id);
              }
            });
          });
          this.replacement_arrow.splice(0, 1, replace_arrow);
          this.replacement_array.splice(0, 1, replacement_goods);
          // console.lconsole.log(this.replacement_array[0]);
        }
      },

      //traverse replacement items while browsing
      replacement(index, item, position) {
        let array_index = 0;
        if (position == 0) {
          this.parent_item = item;
          this.replacement_view = index;
          this.in_replacement = this.replacement_array[0][array_index].id;
          this.goods.splice(index, 1, this.replacement_array[0][array_index]);
        }
        if (position == 1) {
          array_index =
            this.replacement_array[0].findIndex(x => x.id == item.id) + 1;
          this.in_replacement = this.replacement_array[0][array_index].id;
          this.goods.splice(index, 1, this.replacement_array[0][array_index]);
        }
        if (position == -1) {
          array_index =
            this.replacement_array[0].findIndex(x => x.id == item.id) - 1;
          this.in_replacement = this.replacement_array[0][array_index].id;
          this.goods.splice(index, 1, this.replacement_array[0][array_index]);
        }
        if (position == -2) {
          this.replacement_view = null;
          this.goods.splice(index, 1, this.parent_item);
          this.in_replacement = null;
        }
      },

      //traverse complementary items while browsing
      complementary(index, item, position) {
        let array_index = 0;
        if (position == 0) {
          this.parent_item = item;
          this.complementary_view = index;
          this.in_complementary = this.complementary_array[this.parent_item.id][array_index].id;
          this.goods.splice(index, 1, this.complementary_array[this.parent_item.id][array_index]);
        }
        if (position == 1) {
          array_index = this.complementary_array[this.parent_item.id].findIndex(
            x => x.id == item.id
          );
          array_index = array_index + 1;
          this.in_complementary = this.complementary_array[this.parent_item.id][array_index].id;
          this.goods.splice(index, 1, this.complementary_array[this.parent_item.id][array_index]);
        }
        if (position == -1) {
          array_index =
            this.complementary_array[this.parent_item.id].findIndex(x => x.id == item.id) - 1;
          this.in_complementary = this.complementary_array[this.parent_item.id][array_index].id;
          this.goods.splice(index, 1, this.complementary_array[this.parent_item.id][array_index]);
        }
        if (position == -2) {
          this.complementary_view = null;
          this.goods.splice(index, 1, this.parent_item);
          this.in_complementary = null;
        }
      },

      addItemToCart(item, index) {
        var itemInCart = this.checkIfInCart(item);
        if (itemInCart) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });
          var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
          updatedItem.order++;
        } else {
          var updatedItem = {
            order: 1,
            good_id: item.id
          };
        }
        //console.log(updatedItem);
        //inform facebook
        this.$store
          .dispatch("addCartItem", [this.cart.id, updatedItem])
          .then(response => {
            if (
              item.alternative_goods != null &&
              item.alternative_goods.length > 0 &&
              item.check_in_warehouse == 1
            ) {
              //find if id is present in array
              if (item.available_for_customer > 0) {
                if (!this.show_complementary.includes(item.id)) {
                  this.show_complementary.push(item.id);
                }
                this.complementary_index = index;
                this.get_complementary(item, index);
              }
            } else if (item.alternative_goods != null &&
              item.alternative_goods.length > 0 &&
              item.check_in_warehouse == 0) {
              if (!this.show_complementary.includes(item.id)) {
                this.show_complementary.push(item.id);
                this.complementary_index = index;
                this.get_complementary(item, index);
              }
            }
            if (item.id) item.autoship_price = response.data.data.autoship_price;
            //show popup that we are out of good
            if (response.data.data.order < updatedItem.order) {
              console.log("item out of stock");
              // setTimeout(function () {
              // if (item.id != $(".close").attr("item-id")) {
              //   $(".close").trigger("click");
              // }
              if (item.related_goods.length < 1 && item.alternative_goods.length < 1) {
                let outOfStockMessage = "Diemžēl noliktavā šobrīd šīs preces nav. Drīzumā plānojam to saņemt. Ja preču atlikums ir 0, tad reģistrētam klientam - tiklīdz prece atkal būs pieejama, tiks automātiski nosūtīts paziņojums uz e-pastu!"
                $("#good_item_" + item.id).attr('data-content', outOfStockMessage);
              }
              $("#good_item_" + item.id).popup("show");
              // setTimeout(
              //   function () {
              //     $("#good_item_" + item.id).popup("destroy");
              //   }.bind(this),
              //   10000
              // );
              // }, 1000);
              if (item.related_goods != null && item.related_goods.length > 0) {
                this.outofstock = item.id;
                this.replacement_index = index;
                this.get_replacement(item, index);
              } else {
                $("#good_item_" + item.id).popup("show");
                // setTimeout(
                //   function () {
                //     $("#good_item_" + item.id).popup("destroy");
                //   }.bind(this),
                //   5000
                // );
              }
            }
            else {
              this.$store.dispatch("loadActiveCart", this.cart.id);
            }
            fbq("track", "AddToCart", {
              content_name: response.data.data.name,
              content_category: "Water",
              content_ids: [response.data.data.good_id],
              content_type: "product",
              value: response.data.data.price_vat,
              currency: "EUR"
            });
          })
          .catch(error => {
            console.error("Cart was not loaded");
          });
      },

      reduceItemInCart(item) {

        $("#good_item_" + item.id).popup("destroy"); //remove warning about warehouse goods
        var itemInCart = this.checkIfInCart(item);
        if (itemInCart) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });

          var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
          updatedItem.order--;
          //console.log(updatedItem);
          this.$store
            .dispatch("addCartItem", [this.cart.id, updatedItem])
            .then(response => {
              item.autoship_price = response.data.data.autoship_price;
              //if item is totaly removed then remove it from store
              this.$store.dispatch("loadActiveCart", this.cart.id);
              this.outofstock = "";
            })
            .catch(error => {
              console.error("Cart was not loaded");
            });
        }
      },

      resetFilters() {
        //reset filter
        this.$store.commit("SET_CATEGORY_SEARCH_TERM", ""); //will trigger loading of goods
        //   this.loadGoods()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// HomeLastOrderedGoods.vue?4280b1ed